import { auditReports } from '@mi-front/api-clients';
import { MrtTable } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { LDateTime } from '../../../../../../../components/date/LDateTime';

export function UnverifiedBcrEntriesTable({ data }: { data: auditReports.BcrEntryDto[] }) {
  const { $t } = useIntl();

  return (
    <MrtTable
      data={data}
      columns={[
        {
          id: 'datetime',
          header: $t({
            id: 'audit.reportsScreen.bcrMatches.unverifiedBcrEntries.datetime',
            defaultMessage: 'Fecha y hora',
          }),
          accessorFn: (row) => (row.datetime ? new Date(row.datetime) : null),
          Cell: ({ row }) => <LDateTime value={row.original.datetime} showSeconds />,
          enableSorting: true,
          enableColumnFilter: false,
          filterVariant: 'time-range',
          size: 150,
        },
        {
          id: 'customId',
          header: $t({
            id: 'audit.reportsScreen.bcrMatches.unverifiedBcrEntries.customId',
            defaultMessage: 'Custom ID',
          }),
          accessorKey: 'customId',
          enableSorting: true,
          enableColumnFilter: true,
          filterFn: 'contains',
          size: 150,
        },
        {
          id: 'name',
          header: $t({
            id: 'audit.reportsScreen.bcrMatches.unverifiedBcrEntries.name',
            defaultMessage: 'Nombre',
          }),
          accessorKey: 'name',
          enableSorting: true,
          enableColumnFilter: true,
          filterFn: 'contains',
        },
      ]}
    />
  );
}
